export const DATA_NOT_FOUND = ["No Data Found"];
export const CREDENTIAL_MISMATCH = "You cannot login with this credentials"